const numeric = (value) => {
  if (!value) return undefined;
  const regex = /^[0-9 .]+$/;
  return (!regex.test(value) ? 'Numeric characters only' : undefined);
};

export default numeric;